import React, { useEffect, useState } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AssingCommission from "./AssignCommission";
import ProductMaster from "./ProductMaster";
import LedgersReport from "./LedgersReport";
import CommissonDashboard from "./CommissonDashboard";
import { selectCurrentRoles } from "features/auth/authSlice";
import {  useSelector } from "react-redux";
import BankingTabSection from "features/banking/BankingTabSection";

const Commission = () => {
  const [value, setValue] = useState(0);
    const RolesFromToken = useSelector(selectCurrentRoles);
  
  useEffect(() => {
    var x = JSON.parse(localStorage.getItem("activeBankingTab"));
    setValue(x);
  }, []);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
 
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("activeBankingTab", JSON.stringify(newValue));
  };
  console.log("RolesFromToken",RolesFromToken)
  return (
    <div>
        {(!RolesFromToken?.groups?.includes("State Head")||RolesFromToken?.groups?.includes("Banking Admin"))&&(
            <BankingTabSection activeTab="Commission"/>
          )
           }
      <div className="d-flex justify-content-between mx-3 mt-2 mb-2">
        <Tabs value={value} onChange={handleChange} textColor="primary">
          <Tab className="" label="PRODUCTS" iconPosition="start" />
          <Tab label="AGENTS" iconPosition="start" />
          <Tab label="LEDGERS REPORT" iconPosition="start" />
          <Tab label="DASHBOARD" iconPosition="start" />
        </Tabs>
      </div>
      <TabPanel value={value} index={0}>
        <div className="mt-1">
          <ProductMaster />
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AssingCommission />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div className="mt-1">
          <LedgersReport />
        </div>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <div className="mt-1">
          <CommissonDashboard />
        </div>
      </TabPanel>
    </div>
  );
};

export default Commission;
